"use strict";

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
        }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];return o(n || r);
        }, p, p.exports, r, e, n, t);
      }return n[i].exports;
    }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }return r;
})()({ 1: [function (require, module, exports) {
    'use strict';

    (function ($) {
      var injectedScripts = false;

      function loadScript(url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState) {
          // only required for IE <9
          script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              callback();
            }
          };
        } else {
          //Others
          script.onload = function () {
            callback();
          };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
      }

      function loadScripts(urls, callback, index) {
        if (!index) {
          index = 0;
        }

        if (!urls[index]) {
          callback();
        }

        loadScript(urls[index], function () {
          loadScripts(urls, callback, index + 1);
        });
      }

      $(document.body).on('click', '[data-key="php_fallback"] textarea', function () {
        if ($(this).hasClass('codemirror-initialized')) {
          return;
        }

        if (!injectedScripts) {
          injectedScripts = true;

          var self = this;

          loadScripts(['https://codemirror.net/mode/php/../../lib/codemirror.js', 'https://codemirror.net/mode/php/../../addon/edit/matchbrackets.js', 'https://codemirror.net/mode/php/../htmlmixed/htmlmixed.js', 'https://codemirror.net/mode/php/../xml/xml.js', 'https://codemirror.net/mode/php/../javascript/javascript.js', 'https://codemirror.net/mode/php/../css/css.js', 'https://codemirror.net/mode/php/../clike/clike.js', 'https://codemirror.net/mode/php/php.js'], function () {
            initCodeMirror(self);
          });

          // $('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.46.0/codemirror.js"></script>');
          $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.46.0/codemirror.css" />');
          $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.46.0/theme/pastel-on-dark.min.css" />');
        } else {
          initCodeMirror(this);
        }
      });

      function initCodeMirror(input) {
        $(input).addClass('codemirror-initialized');

        var editor = CodeMirror.fromTextArea(input, {
          // readOnly: false,
          matchBrackets: true,
          // // mode: "php",
          mode: 'application/x-httpd-php-open',
          indentUnit: 2,
          indentWithTabs: false,
          autofocus: true,
          // theme: 'pastel-on-dark',
          startOpen: true,
          lineNumbers: false,
          viewportMargin: Infinity,
          onChange: function onChange(cm) {
            $(input).val(cm.getValue());
          }
        });
        editor.on('blur', function () {
          $(input).val(editor.getValue()).trigger('change');
        });

        editor.setSize('100%', 'auto');
      }
    })(jQuery);
  }, {}] }, {}, [1]);